module.exports = __webpack_public_path__ + "static/media/4.1415816d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row1/4.wav
// module id = 32
// module chunks = 0